import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import clsx from 'clsx';
import Icon from '../atoms/Icon';
import styles from '../../styles/components/atoms/Property.module.scss';

interface PropertyProps {
  className?: string;
  onClick?: (e: any) => void;
  icon?: string;
  label?: string;
  value?: any;
  unit?: string;
  dark?: boolean;
  em?: boolean;
  full?: boolean;
  half?: boolean;
  float?: boolean;
  small?: boolean | true;
  medium?: boolean;
  large?: boolean;
  iconRight?: boolean;
  iconSplit?: string;
  restricted?: boolean;
}

export default function Property(props: PropertyProps) {
  const { t } = useTranslation(['common']);
  const {
    icon,
    label,
    value,
    unit,
    em,
    dark,
    onClick,
    full,
    half,
    float,
    small,
    medium,
    large,
    iconRight,
    iconSplit,
    restricted,
    className,
  } = props;
  const router = useRouter();
  const { locale } = router;
  const { property } = styles;
  const h = large ? 'large' : medium ? 'medium' : 'small'; //small ? "small" : "";
  const w = full ? 'full' : half ? 'half' : '';
  const bold = em || icon === 'rating';
  const isBoolean = typeof value === 'boolean';

  const val = isBoolean
    ? t(`common:${!!value}`)
    : value
    ? (value || '').toLocaleString(locale, { maximumFractionDigits: 2 })
    : '';
  const link = val.indexOf('http') === 0;
  const linkLabel = val.split('//')[1];
  const classes = clsx(
    property,
    styles[h],
    { [styles.restricted]: restricted },
    { [styles.float]: float },
    { [styles.full]: full },
    { [styles.dark]: medium ? false : !!dark },
    { [styles.iconRight]: iconRight }
    // {[styles.linked]: !!onClick},
    // {[styles.labeled]: !!label}
  );

  const valueElement = !!iconSplit ? (
    val.split(iconSplit).map((el: any, i: any) => {
      return (
        <span key={i} className={styles.splitValue}>
          <Icon name={`${icon}${i + 1}`} />
          {el}
        </span>
      );
    })
  ) : bold ? (
    <b>{val}</b>
  ) : (
    val
  );

  return (
    <span className={classes} onClick={onClick}>
      {!!icon && !!!iconSplit && <Icon name={icon} />}
      <small>
        <span>{!!label && bold ? <b>{label}</b> : `${label || ''}`}</span>
        {!medium && <span>{valueElement}</span>}
        {!medium && <span>{!!unit && unit}</span>}
      </small>
      {medium && (
        <p>
          {link ? (
            <a href={val} target="_blank" rel="noopener noreferrer">
              {linkLabel}
            </a>
          ) : (
            <>
              {val} {!!unit && unit}
            </>
          )}
        </p>
      )}
    </span>
  );
}
